module.exports = __webpack_public_path__ + "img/tractor-motor.3e1f68d7.png";